const Upload = () => (
  <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M33.3337 33.3333L25.0003 25L16.667 33.3333'
      stroke='#3A98AB'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M25 25V43.75'
      stroke='#3A98AB'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M42.4792 38.3132C44.5112 37.2055 46.1164 35.4526 47.0414 33.3312C47.9665 31.2098 48.1588 28.8408 47.588 26.598C47.0171 24.3552 45.7156 22.3664 43.8889 20.9454C42.0622 19.5245 39.8143 18.7523 37.5 18.7507H34.875C34.2444 16.3117 33.0691 14.0473 31.4374 12.1278C29.8057 10.2083 27.7601 8.68376 25.4544 7.66867C23.1487 6.65358 20.6429 6.1744 18.1253 6.26716C15.6077 6.35992 13.1439 7.0222 10.9192 8.20421C8.69439 9.38622 6.76652 11.0572 5.2805 13.0915C3.79448 15.1259 2.78898 17.4706 2.33958 19.9495C1.89018 22.4283 2.00859 24.9768 2.6859 27.4034C3.36321 29.8299 4.58179 32.0713 6.25004 33.9591'
      stroke='#3A98AB'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default Upload
